import React from "react";
import classNames from "classnames/bind";

import styles from "./Ribbon.module.scss";
const cx = classNames.bind(styles);

const OldRibbon = ({ label, classname, ...rest }) => {
  return (
    <div className={cx("old-ribbon", classname)} {...rest}>
      {label}
    </div>
  );
};

export default OldRibbon;
